var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 0H5C2.239 0 0 2.239 0 5V19C0 21.761 2.239 24 5 24H19C21.762 24 24 21.761 24 19V5C24 2.239 21.762 0 19 0ZM16 7H14.076C13.461 7 13 7.252 13 7.889V9H16L15.762 12H13V20H10V12H8V9H10V7.077C10 5.055 11.064 4 13.461 4H16V7Z","fill":"currentColor"}));
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","focusable":"false"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
